import styles from "../switchCheckbox/switchCheckbox.module.scss";
import {
  FieldValues,
  useController,
  UseControllerProps
} from "react-hook-form";

type SwitchCheckboxHookFormProps<T extends FieldValues> = {
  disabled?: boolean;
} & UseControllerProps<T>;

export const SwitchCheckboxHookForm = <T extends FieldValues>({ disabled, control, name, rules, defaultValue }: SwitchCheckboxHookFormProps<T>) => {

  const {
    field: { ref, ...inputProps },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  return (
    <label className={styles.checkboxIos}>
      <input type="checkbox"
             {...inputProps}
             checked={inputProps.value}
             disabled={disabled}
             ref={ref}
      />
      <span className={styles.checkboxIosSwitch}></span>
    </label>
  );
};
